import type { ReactNode } from "react";

export const H2 = ({ children }: { children: ReactNode }) => {
  return (
    <h1 className="font-FKScreamer text-[48px] font-normal uppercase leading-[85%] text-[#0E0F0F] md:text-[64px]">
      {children}
    </h1>
  );
};
